/** @jsxImportSource @emotion/react */
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Typography,
} from '@mui/material'
import { Section } from '../../../../components'
import { content } from './snowload.content'
import { styles } from './snowload.styles'

export default function SnowProtectionModal({ isOpen, onClose, ...props }) {
  const modal = content.modals.snowProtectionKind
  return (
    <Dialog fullWidth maxWidth={'sm'} open={isOpen} onClose={onClose} {...props}>
      <DialogTitle>{modal.headline}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {modal.items.map((item, index) => (
            <Section
              key={`${item.tile}-${index}`}
              spacing={index && 'topLarge'}
              headline={item.title}
              subline={item.text}
            >
              <div css={styles.equipmentImage}>
                <img src={item.image} alt={item.title} />
                <Typography>{item.title}</Typography>
              </div>
            </Section>
          ))}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{content.ui.close}</Button>
      </DialogActions>
    </Dialog>
  )
}
